import { FC, ReactNode, memo } from 'react'
import { useDispatch } from 'react-redux'
import { useActivating } from 'store/account/hooks'
import { ConnectButtonWrap } from './ConnectWallet'
import { updateModal } from 'store/app/actions/modalActions'

export const OpenMyAccountButton: FC<{ children?: ReactNode }> = memo(
  ({ children }) => {
    const activating = useActivating()
    const dispatch = useDispatch()

    return (
      <ConnectButtonWrap
        loading={activating}
        disabled={activating}
        onClick={() => {
          dispatch(updateModal({ modal: 'guide', open: true }))
        }}
      >
        {children ?? `Open My Account`}
      </ConnectButtonWrap>
    )
  },
)
